import React, { FC } from "react";
import { SuggestionTypes } from "stentor-models";
import { SuggestedAction } from "../SuggestedAction";
import "./SuggestedActions.scss";
import "@xapp/chat-widget-core/dist/index.css";

export interface SuggestedActionsProps {
    readonly actions: readonly SuggestionTypes[];
    onActionClick(action: SuggestionTypes): void;
}

export const SuggestedActions: FC<SuggestedActionsProps> = props => {
    const { actions, onActionClick } = props;
    return (
        <div className="xapp-search-suggested-actions">
            <div className="xapp-search-suggested-actions__actions">
                {actions.map((act, index) => (
                    <SuggestedAction
                        key={index}
                        action={act}
                        className="xapp-search-suggested-actions__item"
                        onClick={onActionClick}
                    />))}
            </div>
        </div>
    );
};